import { Helmet } from 'react-helmet';
import { useState } from 'react';
import '../assets/styles/Gallery.css';

function Gallery() {
  const slides = [
    {
      title: 'Reliable Ocean Freight',
      description: 'Efficient and cost-effective ocean transport solutions.',
      image: '/assets/images/track-41.jpg',
    },
    {
      title: 'Swift Air Freight',
      description: 'Fast and secure air transport for urgent shipments.',
      image: '/assets/images/track-17.jpg',
    },
    {
      title: 'Cargo Express Delivery',
      description: 'Rapid and reliable express shipping for time-sensitive cargo.',
      image: '/assets/images/track-26.jpg',
    },
    {
      title: 'Secure Warehousing',
      description: 'Flexible storage solutions for your logistics needs.',
      image: '/assets/images/bg-about-22.jpg',
    },
    {
      title: 'Tailored Contract Logistics',
      description: 'Comprehensive logistics solutions customized to your business.',
      image: '/assets/images/blog-post-1.jpg',
    },
    {
      title: 'Global Reach, Local Expertise',
      description: 'Seamless logistics services connecting you worldwide.',
      image: '/assets/images/slider-loading-image1.jpg',
    },
  ];

  const [modalImageIndex, setModalImageIndex] = useState(null);

  const openModal = (index) => setModalImageIndex(index);
  const closeModal = () => setModalImageIndex(null);
  const prevImage = () => setModalImageIndex((modalImageIndex - 1 + slides.length) % slides.length);
  const nextImage = () => setModalImageIndex((modalImageIndex + 1) % slides.length);

  return (
    <>
      <Helmet>
        <title>RFF Cargo: Gallery</title>
        <meta name="description" content="Explore our gallery showcasing RFF Cargo’s logistics operations and achievements." />
      </Helmet>
      <section className="gallery-section py-5">
        <div className="container">
          <h2 className="gallery-title fw-bold mb-4">Gallery</h2>
          <p className="gallery-description">
            A visual journey through our logistics services and global operations.
          </p>
          <div className="row gallery-grid">
            {slides.map((slide, index) => (
              <div key={index} className="col-md-4 gallery-grid-item mb-4">
                <div className="gallery-image-container">
                  <img
                    src={slide.image}
                    className="img-fluid"
                    alt={slide.title}
                    onClick={() => openModal(index)}
                  />
                  <div className="gallery-overlay">
                    <div className="gallery-overlay-content">
                      <h3 className="gallery-overlay-title">{slide.title}</h3>
                      <p className="gallery-overlay-description">{slide.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal for Enlarged Image */}
        {modalImageIndex !== null && (
          <div className="gallery-modal" role="dialog" aria-label="Image Modal">
            <div className="gallery-modal-content">
              <button
                className="gallery-modal-close"
                onClick={closeModal}
                aria-label="Close modal"
              >
                ×
              </button>
              <img
                src={slides[modalImageIndex].image}
                className="gallery-modal-image"
                alt={slides[modalImageIndex].title}
              />
              <button
                className="gallery-modal-prev"
                onClick={prevImage}
                aria-label="Previous image"
              >
                <span className="bi bi-chevron-left"></span>
              </button>
              <button
                className="gallery-modal-next"
                onClick={nextImage}
                aria-label="Next image"
              >
                <span className="bi bi-chevron-right"></span>
              </button>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default Gallery;